
























































import {
    defineComponent,
    PropType,
} from '@vue/composition-api';
import {
    SdsCarousel,
    SdsSectionTitle,
} from '@superbet-group/web.lib.ui-components';
import { SelectionSourceScreen } from '@superbet-group/web.types';
import { Route } from 'vue-router';

import OfferEvent from '@core/models/offer/OfferEvent';
import {
    ScreenWidth,
    useVueRouter,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import { SportOfferDataStore } from '@store/modules/data/sportOffer';
import EventRow from '@modules/eventGrid/components/EventRow/index.vue';
import { getPrimaryMarket } from '@store/modules/ui/sportOffer/marketFilters/rawFunctions';
import { BetslipStore } from '@store/modules/ui/betSlip';
import { useItemsPerCarouselSlide } from '@shared/composables/carouselSlide';
import { RouteName } from '@src/app/router/constants/RouteName';
import { getEventSlugFromEvent } from '@modules/eventDetailsPage/utils';
import {
    EventCardSource,
    ExpandedEventInUrl,
} from '@src/app/enums';
import { getUniqueTournamentId } from '@store/modules/ui/sportOffer/marketFilters/helpers';
import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';
import { ClickName } from '@superbet-group/product.analytics';
import {
    createSelfCleaningClientStorage,
    SelfCleaningClientStorage,
} from '@core/utils/selfCleaningClientStorage/createSelfCleaningClientStorage';
import { PeerUrgencyExperimentVariant } from '@core/models/user/flags';
import EventRowSkeleton from '@modules/eventGrid/components/EventRow/EventRowSkeleton.vue';
import { useSdsCarouselBreakpointVariant } from '@shared/composables/useSdsCarouselBreakpointVariant';

export default defineComponent({
    props: {
        items: {
            type: Array as PropType<OfferEvent[]>,
            required: true,
        },
        itemsPerGroup: {
            type: Number,
            default: 2,
        },
        title: {
            type: String,
            required: true,
        },
        titleDescription: {
            type: String,
            required: false,
            default: undefined,
        },
        areEventsFetched: {
            type: Boolean,
            required: true,
        },
        sectionPath: {
            type: String,
            default: null,
        },
        titleIcon: {
            type: String,
            default: undefined,
            required: false,
        },
        isTitleIconThemed: {
            type: Boolean,
            required: false,
            default: false,
        },
        primaryMarketAttribute: {
            type: String,
            default: undefined,
            required: false,
        },
        sourceScreen: {
            type: Number as PropType<SelectionSourceScreen>,
            required: false,
            default: SelectionSourceScreen.Unknown,
        },
        eventCardSource: {
            type: String as PropType<EventCardSource>,
            required: true,
        },
        seeMoreRoute: {
            type: Object as PropType<Route>,
            required: false,
            default: undefined,
        },
        bettorNumberCache: {
            type: Object as PropType<SelfCleaningClientStorage<number, number>>,
            required: false,
            default: () => createSelfCleaningClientStorage<number, number>('bettorNumberCache'),
        },
        socialProofDesignVariant: {
            type: String as PropType<PeerUrgencyExperimentVariant>,
            required: false,
            default: PeerUrgencyExperimentVariant.None,
        },
    },
    setup(props) {
        const sportOfferDataStore = useVuexStore<SportOfferDataStore>('data/sportOffer');
        const sportOfferBetslipStore = useVuexStore<BetslipStore>('ui/sportOffer/betSlip');

        const { numberOfItemsPerSlide: numberOfEventsPerSlide } = useItemsPerCarouselSlide({ [ScreenWidth.tMd]: props.itemsPerGroup });
        const { router } = useVueRouter();

        const onEventClick = (event: OfferEvent, index: number) => {
            AnalyticsSDK.getInstance().log('click', {
                click_name: ClickName.MATCH_DETAILS_CLICK,
                click: {
                    click_value: index.toString(),
                    type: 'general_click',
                },
            });

            router.value.push({
                name: RouteName.Sport.OfferEvent,
                params: { eventSlug: getEventSlugFromEvent(event) },
                query: {
                    [ExpandedEventInUrl.type]: getUniqueTournamentId(
                        'offer',
                        event.tournamentId,
                        event.isOngoing(),
                    ),
                },
            });
        };

        const { carouselLayoutVariant, carouselLayoutValue } = useSdsCarouselBreakpointVariant();

        return {
            numberOfEventsPerSlide,
            carouselLayoutVariant,
            carouselLayoutValue,
            eventsMap: sportOfferDataStore.getter('eventsMap'),
            eventOddMap: sportOfferBetslipStore.getter('eventOddMap'),
            oddValueDynamics: sportOfferDataStore.getter('oddValueDynamics'),

            getPrimaryMarket,
            onEventClick,
        };
    },
    components: {
        SdsSectionTitle,
        SdsCarousel,
        EventRow,
        EventRowSkeleton,
    },
});
